module.exports = function getResource(label, vars = []) {
    const resources = { addTheseTitle: 'Add These for Under $15' };

    return resources[label];
};
